// orgIcon.js — where an agent's square icon is, found from its logo. Plain JS on purpose: the page server
// (relay-server/index.js) imports it too, so the favicon in the HTML and the one the app sets agree.
//
// The agent record has one image setting for icons, so a square icon cannot be named in it. Instead the icon is
// the file that sits beside the logo and is named after the folder: /org/gds/GDS-Brand-Logo-518-2025.png ->
// /org/gds/gds-ico.png. If that file does not exist the caller simply falls through to the next source.

/** '/org/gds/anything.png' -> '/org/gds/gds-ico.png'; '' when the logo is not a path inside a folder on this site. */
export function squareIconPathFor(logoPath) {
  if (typeof logoPath !== 'string' || !logoPath.startsWith('/') || logoPath.startsWith('//')) return '';
  const parts = logoPath.split(/[?#]/)[0].split('/').filter(Boolean);
  if (parts.length < 2) return '';
  parts.pop(); // the file name
  const folder = parts[parts.length - 1];
  return `/${parts.join('/')}/${folder}-ico.png`;
}

/**
 * Icon sources for an agent, best first (the first that loads wins):
 *  1. its `favicon`, when that is a different image from its logo (someone set a real icon)
 *  2. the square icon beside its logo
 *  3. its favicon, then its logo (a wide logo is fitted, never stretched)
 *  4. anything the caller adds (for example the default)
 */
export function iconSources(org, extra = []) {
  const logo = org?.logo;
  const favicon = org?.favicon;
  const list = [
    favicon && favicon !== logo ? favicon : '',
    squareIconPathFor(logo || favicon),
    favicon,
    logo,
    ...extra,
  ].filter(Boolean);
  return [...new Set(list)];
}
